// The page publishes a content version for each worker independently of its
// own bundle. Fixed worker URLs can otherwise keep an older protocol decoder.
export function createViewerWorker(name) {
    const url = globalThis.document?.querySelector(`meta[name="${name}-url"]`)?.content;
    return new Worker(url || `/dist/${name}.js`, { type: 'module' });
}
